import { formatHistoricalDate } from "rant-utils";
import { api } from "../../api/api";
import { AutoForm } from "../../core/form/AutoForm";
import { Dropdown } from "../../core/form/Dropdown";
import { Static } from "../../core/form/Static";
import { Text } from "../../core/form/Text";
import { useApi } from "../../core/hooks/useApi";
import { DataContext, useDataContext } from "../../core/hooks/useData";
import { hasRole, useSession } from "../../core/hooks/useSession";
import { DataAwareButton } from "../../core/ui/DataAwareButton";
import { newNotification } from "../../core/ui/Notification";
import { Spinner } from "../../core/ui/Spinner";
import { Table } from "../../core/ui/Table";
import { Icon } from "../../core/ui/icons";
import { validateEmail } from "../../core/utils/validate";
import { account_invite } from "../../types";
import { Page } from "../Page";


export function Billing(props: {

}) {

	const context = useDataContext({ 
		initialValue: {
		} as any,
	});

	const user = useApi({
		request: () => api.user_get(),
		data: context,
	}, []);

	return (
		<DataContext.Provider value={context}>
			<Page
				compact={true}

				title={{
					text: "Billing",
					secondary: <h2><Static prop="email" /></h2>,
					icon: "employee_tag_color",

					primaryButton: <DataAwareButton
						onClick={() => {
							api.user_post(context.value).then(() => {

							}).catch(() => {

							});
						}}
					>Save</DataAwareButton>
				}
			}>

				<div className="flex vert gap-10 align-start" style={{marginRight:"40px"}}>

					<div className="flex horiz align-start gap-10">
						<div className="flex vert gap-10 align-start">
							<fieldset>
								<legend>Name</legend>

								<AutoForm fields={[
									{ prop: "name.given1", title: "Given Name", options: { required: true } },
									{ prop: "name.family", title: "Family Name", options: { required: true } },
								]} />

							</fieldset>
						</div>

						<div className="flex vert gap-10">
							<fieldset>
								<legend>Phone</legend>

								<AutoForm fields={[
									{ prop: "mobile", title: "Mobile" },
								]} />

							</fieldset>

						</div>

						{/* <div>
							<fieldset>
								<legend>Address</legend>

								<AutoForm fields={[
									{ prop: "careOf", title: "Care Of" },
									{ prop: "line2", title: "Room / Floor / Building / PO Box" },
									{ prop: "street", title: "Street Address" },
									{ prop: "suburb", title: "Suburb / Town" },
									{ prop: "state", title: "State" },
									{ prop: "postCode", title: "Post Code" },
									{ prop: "country", title: "Country" },
								]} />

							</fieldset>
						</div> */}
					</div>

					<fieldset className="width-auto">
						<legend>My Access</legend>

						<MyAccess />
					</fieldset>

				</div>
				
			</Page>
		</DataContext.Provider>
	);
}

export function MyAccess(props: {

}) {

	const accounts = useApi({
		request: () => api.user_accounts(),
	}, []) as any[];

	const session = useSession();

	const dataContext = useDataContext({ initialValue: { 
		account: session.authToken!.account,
		inviteEmail: "",
		inviteName: "",
	} })

	const items = [] as any[];

	if (!accounts) {
		items.push(
			<Spinner size="small" key="spinner" />,
		)
	} else {
		items.push(
			<div className="flex horiz align-end" key="change-account">
				<Dropdown
					items={accounts}
					getDisplay={(item, selected) => {
						return item.account.name;
					}}
					getValue={(item) => {
						return item.account.id;
					}}
					prop="account"
					
				/>
				<button
					onClick={() => {
						api.user_change_account({ toAccount: dataContext.value.account }).then(() => {
							// go back to dashboard
							document.location.href = "/dashboard/";

						}).catch(() => {

						})
					}}
				>Change Account</button>
			</div>

		)
	}
 
	return (
		<DataContext.Provider value={dataContext} key="selection">
			<div className="flex vert gap-10 align-start">
				{items}

				{
					hasRole("account-owner") && 
					<div className="">
						<div>Invite another person to join your account</div>
						<div>
							<Text
								title="Name of person to invite"
								prop="inviteName"
							/>
							<Text
								title="Email address"
								prop="inviteEmail"
							/>
							<button
								className="primary"
								onClick={() => {
									const email = dataContext.value.inviteEmail;
									const name = dataContext.value.inviteName;

									if (!name) {
										newNotification({
											title: "Name is required",
											message: "Please enter the name of the person you are inviting and try again.",
											style: "error",
											type: "modal",										
										})
										return;
									}
									if (!validateEmail(email)) {
										newNotification({
											title: "Email address not valid",
											message: "Please check you have typed the email address correctly and try again.",
											style: "error",
											type: "modal",										
										})
										return;
									}

									api.account_invite({
										email,
										name,
									}).then(() => {

									}).catch(() => {

									})

									newNotification({
										title: "Invitation sent",
										message: 
											<div className="flex vert gap-10 align-center">
												<div>An email has been sent to <b>{email}</b> inviting them to join this account.</div>
												<Icon type="email_send_color" />
											</div>,
										style: "success",
										type: "modal",										
									});

									dataContext.setValue("inviteEmail", "");
									dataContext.setValue("inviteName", "");
								}}
							>Send Invitation</button>
						</div>
					</div>
				}

				{
					hasRole("account-owner") && 
					<Invites />
				}
			</div>
		</DataContext.Provider>
	);

}

export function Invites(props: {

}) {

	const invites = useApi<account_invite[]>({
		request: () => api.account_invite_get_all({}),		
	}, []);

	if (!invites) return null;

	return (
		<Table
			noItemsMesssage="There have not been any invitations sent to other people yet."
			cols={[
				{ id: "email", name: "Invitation sent to", },
				{ id: "name", name: "Name", },
				{ id: "created", name: "Sent", },
				{ id: "accepted", name: "Accepted", },
			]}
			items={invites}
			render={{
				colTitle: (c) => c.name,
				colValue: (r: any, c) => {
					if (c.id === "created") {
						return <div className="tag subtle">{formatHistoricalDate(r.created)}</div>;
					} else if (c.id === "accepted") {
						if (r.dateAccepted) {
							return (
								<div className="tag secondary horiz align-center gap-2 padding-2" style={{display: "flex"}}>
									<Icon type="tick" color="white" size="small" />
									<span>{formatHistoricalDate(r.dateAccepted)}</span>
								</div>
							)
						}
					} else {
						return r[c.id];
					}
				},
			}}

		/>
	)
}